import { decodeBase64 } from '@vista-digital/utilities';
/**
 * Parses an encoded JWT `authToken` to a usable [[ParsedAuthToken]].
 */
export const parseAuthToken = (authToken) => {
    try {
        const payload = authToken.split('.')[1];
        const parsedPayload = JSON.parse(decodeBase64(payload));
        return {
            userId: parsedPayload.sub,
            issuedAt: new Date(parsedPayload.iat * 1000),
            expiresAt: new Date(parsedPayload.exp * 1000)
        };
    }
    catch (_a) {
        throw new Error('Failed to decode and parse JWT token.');
    }
};
//# sourceMappingURL=parse-auth-token.js.map